export enum CardType {
  White = 'white',
  Promo = 'promo',
  Placeholder = 'placeholder',
  Credit = 'CREDIT',
  Debit = 'DEBIT',
  Prepaid = 'PREPAID',
  CREDIT_CARD = 'CREDIT_CARD',
  DEBIT_CARD = 'DEBIT_CARD',
  PRE_PAID_CARD = 'PRE_PAID_CARD'
}
